import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import React from 'react';
import styles from './TableHead.module.css';

type Order = 'asc' | 'desc';

interface IDataTableColumn {
  id: string;
  name: string;
  enableSort?: boolean;
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
}

export interface IDataTableHeadProps {
  columns: IDataTableColumn[];
  order: Order;
  orderBy: string;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
}

const DataTableHead: React.FC<IDataTableHeadProps> = ({ columns, order, orderBy, onRequestSort }): JSX.Element => {
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <React.Fragment>
      <TableHead>
        <TableRow>
          {columns.map(column => (
            <TableCell
              className={styles.dataCell}
              key={column.id}
              align='left'
              sortDirection={orderBy === column.id ? order : false}
            >
              {column.enableSort ? (
                <TableSortLabel
                  className={styles.sortIcon}
                  active={orderBy === column.id}
                  direction={orderBy === column.id ? order : 'asc'}
                  onClick={createSortHandler(column.id)}
                >
                  {column.name}
                </TableSortLabel>
              ) : (
                column.name
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </React.Fragment>
  );
};

export default DataTableHead;
